import { Component } from '@angular/core';

import { ActivatedRoute } from '@angular/router';

import {
  ConceptTopicItem,
  ConfigurationService,
} from 'app/providers/semantria-api/configuration.service';
import { EvaluationService } from 'app/providers/semantria-api/evaluation-service';
import { DocumentAnalysis } from 'app/providers/storage-api/analysis.service';
import {
  EnableClassTelemetry,
  EnableComponentTelemetry,
  injectComponentTelemetryService,
} from 'app/services/otel.service';

import { Utils } from 'app/utils/utils';
import { ConfigurationDetailsTabBase } from '../configuration-details-tab-base';
import { ConfigurationVersionTrackerService } from '../../services/configuration-version-tracker.service';
import { TaxonomyTargetWatcherService } from '../../services/taxonomy-target-watcher.service';

@EnableClassTelemetry()
@Component({
  selector: 'app-configuration-concept-topics',
  templateUrl: './configuration-concept-topics.component.html',
  styleUrls: ['./configuration-concept-topics.component.scss'],
  standalone: false,
})
export class ConfigurationConceptTopicsComponent extends ConfigurationDetailsTabBase<ConceptTopicItem> {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  editingTopic: ConceptTopicItem;

  originalWeight: number;

  isSaving: boolean;

  sliderLimits: { min; max };

  //For concept topics we don't highlight text.  Instead we update the concept topic mat icon to the appropriate checkmark.
  getHighlightText = (doc: DocumentAnalysis, documentText: string, itemValues: string[]) => {
    let hit = false;
    let hitScore = 0;
    if (doc.topics) {
      doc.topics.forEach((topic) => {
        if (itemValues.includes(topic.title) && topic.type === 'concept') {
          hit = true;
          hitScore = topic.strength_score;
        }
      });
    }

    super.setDocumentHitIcon(hit, doc.id, hitScore);

    return documentText;
  };

  constructor(
    protected route: ActivatedRoute,
    protected configVersionTracker: ConfigurationVersionTrackerService,
    private configService: ConfigurationService,
    private evaluationService: EvaluationService,
    private targetWatcher: TaxonomyTargetWatcherService
  ) {
    super(route, configVersionTracker);

    this.itemType = 'Concept Topic';

    this.loadItems = this.configService.getConceptTopics.bind(this.configService);
    this.createItem = this.configService.createConceptTopic.bind(this.configService);
    this.saveItem = this.configService.saveConceptTopic.bind(this.configService);
    this.deleteItem = this.configService.deleteConceptTopic.bind(this.configService);
    this.deleteAllItems = this.configService.deleteAllConceptTopics.bind(this.configService);
    this.evaluateItem = this.evaluationService.evaluateDocuments.bind(this.evaluationService);
    this.getEvaluationConfig = this.configService.getEvaluationConfigId.bind(this.configService);
    this.getItemByClonedFrom = this.configService.getConceptTopicByClonedFrom.bind(
      this.configService
    );
    this.deleteEvaluationConfig = this.configService.deleteConfiguration.bind(this.configService);

    this.sliderLimits = {
      min: 0,
      max: 3,
    };
  }

  onItemEditing($event: ConceptTopicItem) {
    this.editingTopic = $event;

    if ($event) {
      this.editingTopic.weight = Utils.roundHalfAway($event.weight) || 1.0;
      this.originalWeight = $event.weight;
    }
  }

  onItemSaving($event) {
    this.isSaving = $event;
  }

  onItemAdded(topic) {
    super.onItemAdded(topic);
    this.targetWatcher.conceptTopicAdded(topic);
  }

  onItemUpdated(topic) {
    super.onItemUpdated(topic);
    this.targetWatcher.conceptTopicModified(topic);
  }

  onItemsDeleted(topics) {
    super.onItemsDeleted(topics);
    this.targetWatcher.conceptTopicsDeleted(topics);
  }

  onAllItemsDeleted($event) {
    super.onAllItemsDeleted($event);
    this.targetWatcher.allConceptTopicsDeleted($event);
  }

  onWeightChanged(value: number) {
    this.editingTopic.weight = value;
    this.editor.editorTemplateHasChanges.set(+this.editingTopic.weight !== this.originalWeight);
  }

  getItemHighlightValue(item) {
    return [item.name];
  }
}
